// src/services/reservationService.js
// 29차: 신규 생성
// 30차: addReservation 추가 — genre 필드 포함 (EscapeDashboard 장르 선호도용)
// 33차: getBookedTimes 추가 — 특정 날짜의 예약된 시간대 조회 (BookingDetailScreen용)
// 34차: addReservation → runTransaction 기반으로 교체 — 슬롯 중복 방지
// 35차: addReservationWithPoints 추가 — 포인트 차감을 예약 트랜잭션 내에서 원자적 처리
// 36차: changeReservation 추가 — 날짜/시간 변경을 단일 트랜잭션으로 처리
// 39차: PG(Toss) 결제 관련 코드 제거 (tossOrderId 필드 제거)
//       getAllReservations / updateReservationResult 추가 (StoreAdminScreen 연동)
//       addManualReservation 추가 — 매장 관리자 수동 예약 입력용
// 53차: 포인트 보안 이관
//        addReservationWithPoints — 포인트 차감을 CF deductPointsForReservation 으로 이관
//          ① 슬롯 체크 + 예약 문서 생성(클라) → ② 포인트 차감(서버 CF) 순서로 분리
//        changeReservation — 포인트 환불을 CF refundPointsForChange 로 이관
//          트랜잭션 내 직접 users.points 수정 제거
//        클라에서 직접 pointHistory create / users.points update 전면 제거
// 71차: addManualReservation — 슬롯 잠금(reservationSlots) 체크 없이 addDoc만 하던
//        문제 수정. 관리자 수동입력과 고객 앱 동시 예약 시 더블부킹 위험이 있었음.
// 71차: buildReservationPayload 신규 — addReservation/addReservationWithPoints/
//        addManualReservation/recruitService.bulkReserveForRecruit이 각자 채워 넣던
//        reservations 필드를 하나로 통일 (recruit 예약엔 storeId/branchName이 빠져 있었음)
// 72차: cancelReservation에 cancelledBy 옵션 추가 — 점주 취소와 고객 취소를 구분해
//        onReservationCancelled CF가 매장에 알림을 보낼지 판단할 수 있도록
// 74차: buildReservationRedirectUrl 신규 — 예약 저장 후 외부 예약 URL로 이동할 때
//        ThemeDetailScreen/BookingDetailScreen이 각자 쿼리스트링을 만들지 않도록 통일
// 80차: 체험형 공연(정원제) 예약 신규 지원 — getShowSlotCounts/reserveShowSlot/
//        cancelShowReservation 추가, buildReservationPayload에 bookingFormat 스냅샷 필드.
//        기존 방탈출 전세 예약(addReservation 등) 경로는 전혀 안 건드림.
// 80차 후속: 매장관리자용 "간편 일괄 입력" 신규 — addManualDailyTotal(하루 총매출만)/
//        addManualByTheme(테마별 건수·매출) 추가. 외부채널(전화·네이버예약 등) 예약을
//        건별로 일일이 수동입력하기 번거로워 사장님이 아예 입력을 포기하면 매출/건수
//        통계가 실제보다 축소돼 "이 앱이 별 도움이 안 된다"는 이탈로 이어질 수 있다는
//        문제의식에서 신규 — 슬롯 잠금(reservationSlots) 없이 reservations에 집계용
//        문서만 추가(특정 시간대를 실제로 점유하는 게 아니라 통계 반영이 유일한 목적).
//        isManual:true라 onNewReservation의 알림·가격검증·나이검증을 전부 자연히
//        건너뛰고, price/date 필드가 기존 매출 집계 로직(Σprice)에 변경 없이 그대로
//        합산됨 — 다만 "건수"는 문서 1개=1건으로 세는 기존 로직(.length)이 실제 건수를
//        과소평가하므로, 대표성을 나타내는 bulkCount 필드를 추가하고 sumReservationCount
//        헬퍼로 이걸 반영해 셀 것(그냥 .length를 쓰면 다시 과소집계됨 — 호출부 주의).
// 80차 후속: [보안 수정] reservationSlots.read를 소유자 전용으로 좁힘(개인정보 유출 방지
//        — 로그인만 하면 전체 예약자의 uid+테마·시간이 그대로 노출되던 구멍). getBookedTimes/
//        getShowSlotCounts는 CF(getAvailableSlotsCF/getShowSlotCountsCF)로 내부만 교체
//        (시그니처 불변). 타인 소유 슬롯을 transaction.get()하면 이제 not-exists 대신
//        permission-denied가 뜨는데, 더블부킹 방지 자체는 여전히 정확히 동작하므로(트랜잭션
//        실패로 write 자체가 막힘) mapSlotConflictError()로 기존 SLOT_TAKEN 에러 모양만 복원.

import {
  collection, doc, addDoc, getDocs, updateDoc,
  query, where, orderBy,
  runTransaction, getDoc,
} from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions, functionsAsia, auth } from './firebase';
import * as Sentry from '@sentry/react-native';

// 78차: "예약 중 오류(permission-denied)" 재신고 — 실제 커밋 payload를 받아 규칙/데이터를
// 전부 검증했으나(매장 isPaused 아님, 유저 정상, 문서 충돌 없음, 규칙도 배포본과 일치)
// 전부 정상이었음. 남은 유력 원인은 기기에 캐시된 ID 토큰이 만료/직전 상태라 Firestore가
// 조용히 permission-denied로 거부하는 경우 — 예약 트랜잭션 직전에 토큰을 강제 갱신해
// 이 경로를 원천 차단한다(실패해도 무음 처리 후 그대로 진행 — 갱신 자체가 예약을 막으면 안 됨).
// 78차 17차: 같은 에러가 재발(이번엔 총관리자 ID 로그인 계정, 계정을 자주 바꿔가며
// 테스트하던 상황)했는데도 store/유저 데이터는 다시 확인해도 이상 없었음 — 토큰 갱신
// 자체가 실패하고 있는지조차 지금까지 무음이라 알 수 없었던 것도 원인 규명을 막고 있어,
// 갱신 실패 시 Sentry로 남기도록 함(실패해도 예약은 그대로 진행 — 동작 변화 없음).
const refreshAuthToken = async () => {
  try {
    if (auth.currentUser) await auth.currentUser.getIdToken(true);
  } catch (e) {
    Sentry.captureException(e, { tags: { flow: 'reservation_token_refresh' } });
  }
};

// ─── 67차: 예약 슬롯 잠금(lock) 문서 ──────────────────────────
// 기존에는 runTransaction 안에서 getDocs(query)로 중복 체크를 했는데,
// Firestore 클라이언트 트랜잭션은 transaction.get()으로 읽은 문서만 감시(낙관적 동시성 제어)한다.
// 트랜잭션 콜백 안의 일반 getDocs 쿼리는 트랜잭션의 격리·재시도와 무관하게 동작하므로,
// 두 손님이 거의 동시에 같은 슬롯을 예약하면 둘 다 "비어있음"으로 통과해 더블부킹이 날 수 있었다.
// → productId|date|time 을 문서 ID로 하는 잠금 문서를 두고, transaction.get()/set()으로
//   실제 낙관적 동시성 제어가 적용되도록 한다 (동시에 같은 문서를 쓰려 하면 Firestore가 자동 재시도/실패 처리).
// 80차 후속: recruitService.js의 방탈출(room) 모집 그룹예약이 이 잠금 문서를 재사용할
// 수 있도록 export(그동안 그룹예약엔 이 잠금 자체가 없어 더블부킹 방지가 안 되고 있었음).
export const buildSlotId = (productId, date, time) => `${productId}|${date}|${time}`;

// 잠금 문서 도입 이전에 생성된 예약(잠금 문서가 없는 레거시 데이터)과의 충돌을 줄이기 위한
// 트랜잭션 밖 사전 체크. 진짜 동시성 방어는 트랜잭션 내부의 잠금 문서 체크가 담당하고,
// 이 함수는 보조 안전판이다.
// 78차: reservations 컬렉션을 productId/date/time으로 직접 쿼리하고 있었는데,
// firestore.rules 전수조사 중 이 쿼리 모양(uid 무관)이 사실상 "로그인한 아무나 예약
// 컬렉션 전체를 필터만 걸어서 열람 가능"한 구멍의 원인 중 하나였음 — 개인정보가 없는
// reservationSlots(문서ID 자체가 buildSlotId라 쿼리 없이 단건 조회로 충분)로 이관.
// 80차 후속: reservationSlots.read를 소유자 전용으로 좁힌 뒤로는, 남의 슬롯을 get()하면
// "존재 안 함"이 아니라 permission-denied가 뜬다 — 이것도 "슬롯이 차 있다"는 뜻이므로
// 그대로 taken(true)으로 취급(mapSlotConflictError와 동일한 판단 기준).
async function isSlotTakenLegacy(productId, date, time, excludeReservationId = null) {
  try {
    const slotSnap = await getDoc(doc(db, 'reservationSlots', buildSlotId(productId, date, time)));
    if (!slotSnap.exists()) return false;
    return slotSnap.data().reservationId !== excludeReservationId;
  } catch (e) {
    if (e?.code === 'permission-denied') return true;
    throw e;
  }
}

// 80차 후속: reservationSlots.read를 소유자 전용으로 좁힌 부작용 — 남의 슬롯이 이미
// 차 있으면 transaction.get()이 "not exists"가 아니라 permission-denied를 던짐(더블부킹은
// 여전히 정확히 막히지만 에러 모양이 바뀜). 기존 호출부가 기대하는 SLOT_TAKEN으로 통일.
export function mapSlotConflictError(e) {
  if (e?.code === 'permission-denied') return new Error('SLOT_TAKEN');
  return e;
}

// ─── 71차: reservations 문서 payload 빌더 ────────────────────
// addReservation/addReservationWithPoints/addManualReservation/recruitService.js의
// bulkReserveForRecruit 네 곳이 각자 필드를 조금씩 다르게 채워 넣던 것을 통일
// (recruit 일괄예약 쪽엔 storeId/branchName/originalPrice가 아예 빠져 있었음)
export const buildReservationPayload = ({
  uid = null,
  productId,
  productName = '',
  themeName,
  storeName = '',
  branchName = '',
  storeId = null,
  date,
  time,
  people,
  price,
  originalPrice,
  usedPoints = 0,
  duration = 60,
  genre = null,
  paymentType,
  paymentStatus = 'confirmed',
  recruitId = null,
  isManual = false,
  cancelled = false,
  reviewed = false,
  success = null,
  createdAt,
  // 78차 44차: 모집 일괄예약(bulkReserveForRecruit)이 참가자 수만큼 예약 문서를 만드는데
  // 서버 가격검증(onNewReservation)이 각 문서를 전부 "그룹 전체 가격"으로 정정해서, 매출
  // 집계(reduce sum of price)가 참가자 수배로 부풀려지는 문제가 있었음 — 참가자별 개별
  // 문서(리뷰/취소/출석 등은 그대로 개인 단위)는 유지하되, 그룹당 정확히 한 건만 매출
  // 집계 대상에 포함시키기 위한 플래그. true인 문서는 revenue 합산에서 제외할 것
  // (StoreAdminScreen.js/SuperAdminStoresScreen.js/SuperAdminScreen.js/functions/index.js
  // 전부 "active"/"activeRes" 등 매출 기준 배열을 만드는 지점에서 필터링).
  revenueDuplicate = false,
  // 80차: bookingFormat 스냅샷 — 'room'(기본, 방탈출 전세) | 'show'(체험형 공연,
  // reserveShowSlotCF 경유). 보안 경계 아님, 취소/변경 버튼·결과입력 UI가 테마를
  // 재조회하지 않고 예약 문서만 보고 바로 분기하기 위한 표시용 필드.
  bookingFormat = 'room',
  // 80차 후속: 간편 일괄 입력 전용 — 이 한 문서가 실제로 대표하는 예약 건수(기본 1).
  // "예약 건수" KPI는 이 값을 sumReservationCount()로 합산해야 정확함(.length는 항상 1로 셈).
  bulkCount = 1,
  isBulkLog = false,
}) => ({
  uid,
  productId,
  productName:   productName || themeName || '',
  storeName:     storeName   || branchName || '',
  storeId,
  branchName,
  date,
  time,
  // 78차: people이 "2인" 같은 인원선택 라벨 문자열로 넘어올 때(ThemeDetailScreen/
  // BookingDetailScreen의 인원별 가격 버튼) Number("2인")이 NaN이 되어 reservations.people이
  // 조용히 NaN으로 저장되던 버그 수정 — parseInt는 "2인"→2로 안전 변환, 순수 숫자/숫자
  // 문자열(수동입력·크루 일괄예약 등 기존 호출부)도 그대로 동작.
  people:        (parseInt(people, 10) || null),
  price:         Number(price),
  originalPrice: originalPrice !== undefined ? Number(originalPrice) : Number(price),
  usedPoints:    Number(usedPoints),
  duration:      Number(duration),
  genre,
  paymentType,
  paymentStatus,
  recruitId,
  isManual,
  cancelled,
  reviewed,
  success,
  createdAt,
  revenueDuplicate,
  bookingFormat,
  bulkCount: Number(bulkCount) || 1,
  isBulkLog,
});

// 80차 후속: "예약 건수" 집계 전용 헬퍼 — 간편 일괄 입력 문서는 bulkCount만큼의 건수를
// 대표하므로 .length 대신 이걸로 합산해야 함(일반 예약 문서는 bulkCount가 없거나 1이라
// 기존 .length와 동일하게 동작 — 회귀 없음).
export const sumReservationCount = (list) =>
  (list || []).reduce((sum, r) => sum + (Number(r.bulkCount) || 1), 0);

// 80차 후속: [기능 추가] 간편 일괄 입력이 "덮어쓰기가 아니라 항상 추가"라는 걸 사용자가
// 헷갈릴 수 있어서(같은 날 두 번 입력하면 합산됨) — 저장 전에 그날 이미 입력된 내역을
// 보여줘서 실수(의도는 "수정"인데 실제로는 "중복 추가")를 사전에 막기 위한 조회.
// storeId+date+isBulkLog는 전부 등호(==) 조건이라 복합 인덱스 없이도 동작.
export const getManualBulkLogSummary = async ({ storeId, branchName, date }) => {
  const snap = await getDocs(query(
    collection(db, 'reservations'),
    where('storeId', '==', storeId), where('date', '==', date), where('isBulkLog', '==', true),
  ));
  const rows = snap.docs.map(d => d.data()).filter(r => r.cancelled !== true && r.branchName === branchName);
  const byTheme = {};
  let count = 0, revenue = 0;
  rows.forEach(r => {
    const c = Number(r.bulkCount) || 0, rev = Number(r.price) || 0;
    count += c; revenue += rev;
    if (r.productId) {
      const t = byTheme[r.productId] || { count: 0, revenue: 0 };
      t.count += c; t.revenue += rev;
      byTheme[r.productId] = t;
    }
  });
  return { count, revenue, byTheme };
};

// ─── 예약 + 포인트 차감 통합 ────────────────────────────────
// 53차: 포인트 차감 파트를 CF deductPointsForReservation 으로 이관
//   흐름: ① 슬롯 중복 체크 + 예약 문서 생성(클라 트랜잭션)
//          ② 포인트 차감(CF callable) — 서버에서 잔액 검증 + FIFO
//   포인트 차감 CF가 실패하면 예약은 이미 생성된 상태 → 호출처에서
//   예약 취소 또는 재시도 처리 권장 (현행 현장결제 기조상 드문 케이스)
// 에러:
//   'SLOT_TAKEN'          — 슬롯 선점 (예약 생성 전)
//   'INSUFFICIENT_POINTS' — 포인트 부족 (예약 생성 후 CF 실패)
export const addReservationWithPoints = async ({
  uid,
  productId,
  productName,
  storeName,
  date,
  time,
  people,
  price,
  usedPoints = 0,
  duration = 60,
  genre = null,
  paymentType = 'external',
  paymentStatus = 'confirmed',
  recruitId = null,
  themeName,
  storeId,
  branchName,
  originalPrice,
  success,
  reviewed,
  cancelled,
}) => {
  await refreshAuthToken();
  const now = new Date().toISOString();
  const needsSlotCheck = paymentType !== 'recruit' && !!time && !!date && !!productId;

  // 67차: 잠금 문서 도입 이전 예약과의 충돌 방지용 사전 체크 (보조 안전판)
  if (needsSlotCheck) {
    const legacyTaken = await isSlotTakenLegacy(productId, date, time);
    if (legacyTaken) throw new Error('SLOT_TAKEN');
  }
  const slotRef = needsSlotCheck ? doc(db, 'reservationSlots', buildSlotId(productId, date, time)) : null;

  // ── 1. 슬롯 체크 + 예약 문서 생성 (클라 트랜잭션) ──────────
  // 80차 후속: reservationSlots.read가 소유자 전용으로 좁혀져서, 남의 슬롯이 이미 차 있으면
  // transaction.get()이 이제 "not exists"가 아니라 permission-denied를 던짐 — 더블부킹은
  // 여전히 정확히 막히지만(트랜잭션이 그대로 실패), 기존 호출부가 기대하는 SLOT_TAKEN으로 매핑.
  let reservationId;
  try {
    reservationId = await runTransaction(db, async (transaction) => {
    if (slotRef) {
      // 67차: transaction.get()으로 읽어야 Firestore가 실제로 동시성 충돌을 감지한다
      const slotSnap = await transaction.get(slotRef);
      if (slotSnap.exists()) throw new Error('SLOT_TAKEN');
    }

    const newRef = doc(collection(db, 'reservations'));
    transaction.set(newRef, buildReservationPayload({
      uid, productId, productName, themeName, storeName, branchName, storeId,
      date, time, people, price, originalPrice, usedPoints, duration, genre,
      paymentType, paymentStatus, recruitId,
      cancelled: cancelled ?? false, reviewed: reviewed ?? false, success: success ?? null,
      createdAt: now,
    }));

    if (slotRef) {
      transaction.set(slotRef, {
        reservationId: newRef.id,
        productId, date, time, uid,
        createdAt: now,
      });
    }

    return newRef.id;
    });
  } catch (e) {
    throw mapSlotConflictError(e);
  }

  // ── 2. 포인트 차감 (서버 CF) ────────────────────────────────
  if (usedPoints > 0) {
    try {
      const cf = httpsCallable(functionsAsia, 'deductPointsForReservation');
      await cf({ uid, usedPoints, productName: productName || themeName || '', date });
    } catch (err) {
      // 포인트 차감 실패 — 예약은 이미 생성된 상태
      // 현장결제 기조상 포인트 없어도 현장 결제 가능하나, 호출처에서 err 캐치 후 안내 권장
      const errMsg = err?.message || '';
      if (errMsg.includes('INSUFFICIENT_POINTS')) throw new Error('INSUFFICIENT_POINTS');
      throw err;
    }
  }

  return reservationId;
};

// ─── 예약 생성 (트랜잭션, 포인트 없는 경우) ────────────────
export const addReservation = async ({
  uid,
  productId,
  productName,
  storeName,
  date,
  time,
  people,
  price,
  usedPoints = 0,
  duration = 60,
  genre = null,
  paymentType = 'external',
  paymentStatus = 'confirmed',
  recruitId = null,
  themeName,
  storeId,
  branchName,
  originalPrice,
  success,
  reviewed,
  cancelled,
}) => {
  if (usedPoints > 0) {
    return addReservationWithPoints({
      uid, productId, productName, storeName, date, time, people,
      price, usedPoints, duration, genre, paymentType, paymentStatus,
      recruitId, themeName, storeId, branchName,
      originalPrice, success, reviewed, cancelled,
    });
  }

  await refreshAuthToken();
  const now = new Date().toISOString();
  const needsSlotCheck = paymentType !== 'recruit' && !!time && !!date && !!productId;

  if (needsSlotCheck) {
    // 67차: 잠금 문서 도입 이전 예약과의 충돌 방지용 사전 체크 (보조 안전판)
    const legacyTaken = await isSlotTakenLegacy(productId, date, time);
    if (legacyTaken) throw new Error('SLOT_TAKEN');

    const slotRef = doc(db, 'reservationSlots', buildSlotId(productId, date, time));

    try {
      return await runTransaction(db, async (transaction) => {
        // 67차: transaction.get()으로 읽어야 Firestore가 실제로 동시성 충돌을 감지한다
        const slotSnap = await transaction.get(slotRef);
        if (slotSnap.exists()) throw new Error('SLOT_TAKEN');

        const newRef = doc(collection(db, 'reservations'));
        transaction.set(newRef, buildReservationPayload({
          uid, productId, productName, themeName, storeName, branchName, storeId,
          date, time, people, price, originalPrice, usedPoints: 0, duration, genre,
          paymentType, paymentStatus, recruitId,
          cancelled: cancelled ?? false, reviewed: reviewed ?? false, success: success ?? null,
          createdAt: now,
        }));

        transaction.set(slotRef, {
          reservationId: newRef.id,
          productId, date, time, uid,
          createdAt: now,
        });

        return newRef.id;
      });
    } catch (e) {
      throw mapSlotConflictError(e);
    }
  }

  const docRef = await addDoc(collection(db, 'reservations'), buildReservationPayload({
    uid, productId, productName, themeName, storeName, branchName, storeId,
    date, time, people, price, originalPrice, usedPoints: 0, duration, genre,
    paymentType, paymentStatus, recruitId,
    cancelled: cancelled ?? false, reviewed: reviewed ?? false, success: success ?? null,
    createdAt: now,
  }));
  return docRef.id;
};

// ─── 매장 관리자 수동 예약 입력 ─────────────────────────────
export const addManualReservation = async ({
  storeId,
  branchName,
  productId,
  productName,
  date,
  time,
  people,
  price = 0,
  duration = 60,
  genre = null,
  customerName = '',
  customerPhone = '',
  memo = '',
  createdByUid,
}) => {
  const now = new Date().toISOString();
  const reservationData = {
    ...buildReservationPayload({
      productId, productName, branchName, storeId,
      date, time, people, price, usedPoints: 0, duration, genre,
      paymentType: 'manual', isManual: true, createdAt: now,
    }),
    customerName,
    customerPhone,
    memo,
    createdByUid: createdByUid || null,
  };

  const needsSlotCheck = !!productId && !!date && !!time;
  if (!needsSlotCheck) {
    const docRef = await addDoc(collection(db, 'reservations'), reservationData);
    return docRef.id;
  }

  const legacyTaken = await isSlotTakenLegacy(productId, date, time);
  if (legacyTaken) throw new Error('SLOT_TAKEN');

  const slotRef = doc(db, 'reservationSlots', buildSlotId(productId, date, time));
  try {
  return await runTransaction(db, async (transaction) => {
    const slotSnap = await transaction.get(slotRef);
    if (slotSnap.exists()) throw new Error('SLOT_TAKEN');

    const newRef = doc(collection(db, 'reservations'));
    transaction.set(newRef, reservationData);
    // 75차: 수동입력 시 "권한 오류" 버그 수정 — 여기 uid를 null로 넣고 있었는데,
    // firestore.rules의 reservationSlots create 규칙은 uid == request.auth.uid를
    // 요구한다(고객 본인 예약 기준으로 만든 규칙). 수동입력은 고객 uid가 없어 늘
    // null과 매장관리자 자신의 auth.uid가 달라 permission-denied였음 — 이 슬롯 문서는
    // 화면에 노출되지 않는 내부 동시성 잠금용이라 매장관리자 본인 uid를 넣어도 무방.
    // 80차 후속: 고객이 이미 이 슬롯을 잡아둔 경우(uid가 이 관리자와 다름) transaction.get()이
    // permission-denied를 던짐 — 아래 catch에서 SLOT_TAKEN으로 매핑.
    transaction.set(slotRef, {
      reservationId: newRef.id,
      productId, date, time, uid: createdByUid || null,
      createdAt: now,
    });

    return newRef.id;
  });
  } catch (e) {
    throw mapSlotConflictError(e);
  }
};

// ─── 80차 후속: 매장 관리자 간편 일괄 입력 ─────────────────
// 하루 총매출만 입력 — 테마/시간 구분 없이 "오늘 외부채널 예약 O건, 매출 O원"만 기록.
export const addManualDailyTotal = async ({
  storeId, branchName, date, totalCount, totalRevenue, createdByUid,
}) => {
  const now = new Date().toISOString();
  const docRef = await addDoc(collection(db, 'reservations'), {
    ...buildReservationPayload({
      productId: null, productName: '일괄입력(전체)', branchName, storeId,
      date, time: null, people: null, price: totalRevenue, usedPoints: 0,
      paymentType: 'manual', isManual: true, createdAt: now,
      bulkCount: totalCount, isBulkLog: true,
    }),
    createdByUid: createdByUid || null,
  });
  return docRef.id;
};

// 테마별 건수·매출 — 테마마다 "오늘 O건, 매출 O원"을 따로 기록(시간대 구분 없음).
// entries: [{ productId, productName, count, revenue, bookingFormat }] — bookingFormat을
// 넘기면(체험형 테마) 가동률 계산이 쓰는 people 필드에도 count를 함께 채운다(1건=1인
// 근사치 — 정확한 인원수는 이 간편 모드가 받는 입력이 아니므로 알 수 없음, 정밀한
// 인원 통계가 필요하면 기존 상세 수동입력을 쓰도록 안내할 것).
export const addManualByTheme = async ({
  storeId, branchName, date, entries, createdByUid,
}) => {
  const now = new Date().toISOString();
  const ids = [];
  for (const e of entries) {
    if (!e.count || !e.revenue) continue; // 빈 입력은 건너뜀
    const isShow = e.bookingFormat === 'show';
    const docRef = await addDoc(collection(db, 'reservations'), {
      ...buildReservationPayload({
        productId: e.productId, productName: e.productName, branchName, storeId,
        date, time: null, people: isShow ? e.count : null, price: e.revenue, usedPoints: 0,
        paymentType: 'manual', isManual: true, createdAt: now,
        bulkCount: e.count, isBulkLog: true, bookingFormat: e.bookingFormat || 'room',
      }),
      createdByUid: createdByUid || null,
    });
    ids.push(docRef.id);
  }
  return ids;
};

// ─── 71차: normalizeProduct(productService.js)와 동일한 패턴 ─
// 화면들이 각자 item.themeName || item.productName처럼 존재한 적 없는 필드까지
// 방어적으로 폴백하던 것을 한 곳에서 보장 (themeName은 실제로 저장되지 않는 필드)
export const normalizeReservation = (r) => ({
  ...r,
  productName: r.productName || r.themeName || '',
  storeName:   r.storeName   || r.branchName || '',
});

// ─── 매장 전체 예약 조회 (관리자용) ─────────────────────────
export const getAllReservations = async () => {
  const snap = await getDocs(
    query(collection(db, 'reservations'), orderBy('createdAt', 'desc'))
  );
  return snap.docs.map(d => normalizeReservation({ id: d.id, ...d.data() }));
};

// ─── 탈출 결과 업데이트 (관리자용) ──────────────────────────
export const updateReservationResult = async (reservationId, data) => {
  await updateDoc(doc(db, 'reservations', reservationId), {
    ...data,
    updatedAt: new Date().toISOString(),
  });
};

// ─── 수동 예약 메모 업데이트 ────────────────────────────────
// ─── 내 예약 목록 전체 조회 ──────────────────────────────────
export const getMyReservations = async (uid) => {
  const q = query(
    collection(db, 'reservations'),
    where('uid', '==', uid),
    orderBy('createdAt', 'desc'),
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => normalizeReservation({ id: d.id, ...d.data() }));
};

// ─── 예약 취소 ───────────────────────────────────────────────
// 67차: 취소 시 슬롯 잠금 문서도 함께 해제 — 안 하면 취소된 슬롯이 계속 잠긴 상태로 남아
//       다른 손님이 그 시간대를 예약할 수 없게 되는 문제가 생긴다.
// 72차: cancelledBy 옵션 추가 — StoreAdminScreen의 점주 취소 버튼이 'store'를 넘겨야
//       onReservationCancelled CF가 "고객이 취소함"과 구분해 매장에 중복 알림을 안 보낸다.
// 79차: [버그 수정, 심각] 이 함수가 usedPoints를 전혀 환불하지 않고 있었음 — 그런데
// ReservationHistoryScreen.js의 취소 확인/완료 Alert 문구는 둘 다 "사용한 포인트가
// 환불돼요/환불됐어요"라고 명시하고 있어서, 실제로는 취소해도 쓴 포인트를 영구히
// 잃는데 화면은 정반대로 안내하고 있었음(전수 정독으로 발견 — functions/index.js
// 전체를 확인해도 취소 트리거(onReservationCancelled)는 매장 알림만 보낼 뿐 포인트
// 관련 로직이 전혀 없음). changeReservation()이 이미 쓰고 있는 refundPointsForChange
// CF(서버가 reservationId로 직접 usedPoints를 조회해 환불 후 0으로 되돌리는 멱등
// 트랜잭션)를 여기서도 그대로 재사용 — 함수명은 "ForChange"지만 실제로는 예약
// 자체가 아니라 reservationId 하나로 동작해서 취소 시에도 그대로 쓸 수 있음.
// 에러:
//   'RECRUIT_RESERVATION' — 모집 그룹예약은 개인 셀프취소 불가(80차 후속 참고)
export const cancelReservation = async (reservationId, { cancelledBy } = {}) => {
  let usedPoints = 0;
  let productName = '';
  await runTransaction(db, async (transaction) => {
    const resRef  = doc(db, 'reservations', reservationId);
    const resSnap = await transaction.get(resRef);
    if (!resSnap.exists()) return;
    const resData = resSnap.data();
    // 80차 후속: [버그 수정] 모집 그룹예약(room 포맷)은 참가자 전원이 reservationSlots
    // 잠금 하나를 공유하는데, 이 함수는 예약 하나를 취소하며 그 공유 잠금을 그대로
    // delete()해버려서 — 참가자 한 명이 자기 몫만 셀프취소해도 그룹 전체가 아직
    // 확정 상태인 슬롯이 조용히 풀려버릴 수 있었음(다른 손님이 그 시간대를 정상
    // 예약 가능해짐 — 방금 만든 슬롯 잠금 도입의 반대편 구멍). changeReservation()이
    // 이미 이 케이스를 막고 있던 것과 동일하게 차단 — 그룹 취소는
    // cancelBulkRoomReservation(모집 작성자)/매장 전용 경로로만 가능.
    if (resData.paymentType === 'recruit') throw new Error('RECRUIT_RESERVATION');

    transaction.update(resRef, {
      cancelled: true,
      ...(cancelledBy ? { cancelledBy } : {}),
    });

    if (resData.productId && resData.date && resData.time) {
      const slotRef = doc(db, 'reservationSlots', buildSlotId(resData.productId, resData.date, resData.time));
      // 존재하지 않는 문서를 delete()해도 에러가 나지 않으므로 레거시 예약도 안전하게 처리됨
      transaction.delete(slotRef);
    }

    usedPoints  = resData.usedPoints || 0;
    productName = resData.productName || resData.themeName || '';
  });

  if (usedPoints > 0) {
    try {
      const cf = httpsCallable(functionsAsia, 'refundPointsForChange');
      await cf({ reservationId, productName });
    } catch {
      // 환불 실패 — 취소 자체는 완료된 상태. changeReservation과 동일하게 무음 처리.
    }
  }
};

// ─── 예약 날짜/시간 변경 ─────────────────────────────────────
// 53차: 포인트 환불 파트를 CF refundPointsForChange 로 이관
//   트랜잭션 내 직접 users.points 수정 제거
// 에러:
//   'NOT_FOUND'           — 예약 문서 없음
//   'FORBIDDEN'           — 본인 예약 아님
//   'SLOT_TAKEN'          — 변경 슬롯 이미 선점
//   'RECRUIT_RESERVATION' — 모집 예약 변경 불가
export const changeReservation = async ({ reservationId, uid, newDate, newTime }) => {
  const now = new Date().toISOString();
  let usedPoints = 0;
  let productName = '';

  // 67차: 잠금 문서 도입 이전 예약과의 충돌 방지용 사전 체크 (보조 안전판)
  //   트랜잭션 진입 전 가벼운 조회로 productId만 확인 — 진짜 동시성 방어는 트랜잭션 내부가 담당
  const preSnap = await getDoc(doc(db, 'reservations', reservationId));
  const preProductId = preSnap.exists() ? preSnap.data().productId : null;
  if (preProductId) {
    const legacyTaken = await isSlotTakenLegacy(preProductId, newDate, newTime, reservationId);
    if (legacyTaken) throw new Error('SLOT_TAKEN');
  }

  // ── 1. 슬롯 체크 + 예약 날짜/시간 업데이트 (클라 트랜잭션) ─
  await runTransaction(db, async (transaction) => {
    const resRef  = doc(db, 'reservations', reservationId);
    const resSnap = await transaction.get(resRef);
    if (!resSnap.exists()) throw new Error('NOT_FOUND');

    const resData = resSnap.data();
    if (resData.uid !== uid)               throw new Error('FORBIDDEN');
    if (resData.cancelled)                 throw new Error('NOT_FOUND');
    if (resData.paymentType === 'recruit') throw new Error('RECRUIT_RESERVATION');

    const oldSlotId  = buildSlotId(resData.productId, resData.date, resData.time);
    const newSlotId  = buildSlotId(resData.productId, newDate, newTime);
    const sameSlot   = oldSlotId === newSlotId;
    const newSlotRef = sameSlot ? null : doc(db, 'reservationSlots', newSlotId);

    // 67차: transaction.get()으로 읽어야 Firestore가 실제로 동시성 충돌을 감지한다
    // 80차 후속: 새 슬롯이 남(다른 uid)의 소유면 이제 not-exists가 아니라 permission-denied가
    // 뜬다 — resRef read와 구분하기 위해 이 get만 좁게 감싸서 SLOT_TAKEN으로 매핑.
    if (newSlotRef) {
      let newSlotSnap;
      try {
        newSlotSnap = await transaction.get(newSlotRef);
      } catch (e) {
        throw mapSlotConflictError(e);
      }
      if (newSlotSnap.exists()) throw new Error('SLOT_TAKEN');
    }

    transaction.update(resRef, {
      date:      newDate,
      time:      newTime,
      changedAt: now,
    });

    if (newSlotRef) {
      const oldSlotRef = doc(db, 'reservationSlots', oldSlotId);
      // 존재하지 않는 문서를 delete()해도 에러가 나지 않으므로 레거시 예약도 안전하게 처리됨
      transaction.delete(oldSlotRef);
      transaction.set(newSlotRef, {
        reservationId, productId: resData.productId, date: newDate, time: newTime, uid,
        createdAt: now,
      });
    }

    usedPoints  = resData.usedPoints || 0;
    productName = resData.productName || resData.themeName || '';
  });

  // ── 2. 포인트 환불 (서버 CF) ────────────────────────────────
  // 78차: refundAmount를 클라이언트가 계산해서 보내던 것 → 서버가 reservationId로 직접
  // usedPoints를 조회해 검증하도록 이관(전수조사로 발견한 임의 포인트 생성 취약점 수정).
  if (usedPoints > 0) {
    try {
      const cf = httpsCallable(functionsAsia, 'refundPointsForChange');
      await cf({ reservationId, productName, newDate, newTime });
    } catch {
      // 환불 실패 — 예약 변경은 완료된 상태. 무음 처리 (Sentry 연동 권장)
    }
  }
};

// ─── 74차: 외부 예약 URL에 선택한 날짜/시간/인원 쿼리스트링으로 붙이기 ─────
// 매장마다 붙여둔 reservationUrl(자체 예약 시스템)이 이 파라미터를 실제로 읽는지는
// 매장 시스템마다 다를 수 있음 — 우선 일반적인 파라미터명(date/time/people)으로 전달.
export const buildReservationRedirectUrl = (baseUrl, { date, time, people } = {}) => {
  if (!baseUrl) return null;
  const sep = baseUrl.includes('?') ? '&' : '?';
  const peopleCount = String(people || '').replace(/[^0-9]/g, '') || people || '';
  const params = [
    date && `date=${encodeURIComponent(date)}`,
    time && `time=${encodeURIComponent(time)}`,
    peopleCount && `people=${encodeURIComponent(peopleCount)}`,
  ].filter(Boolean).join('&');
  return params ? `${baseUrl}${sep}${params}` : baseUrl;
};

// ─── 특정 테마·날짜의 예약된 시간대 조회 ────────────────────
// 78차: reservations 대신 reservationSlots를 조회하도록 이관(위 isSlotTakenLegacy와 동일한
// 이유 — 전수조사로 발견한 firestore.rules 구멍 수정의 일부). 취소된 예약은 cancelReservation이
// 슬롯 잠금 문서도 같이 지우므로 별도 cancelled 필터가 필요 없고, 실제 트랜잭션 잠금 체크가
// paymentStatus와 무관하게 슬롯 존재 여부만 보는 것과도 이제 일관됨(기존엔 pending 결제
// 예약을 "예약 가능"으로 잘못 보여줘 실제 예약 시도에서만 SLOT_TAKEN이 나는 불일치가 있었음).
// 80차 후속: reservationSlots.read를 소유자 전용으로 좁혀서(개인정보 유출 방지) 클라이언트가
// 더 이상 이 컬렉션을 productId+date로 직접 쿼리할 수 없게 됨 — Admin SDK CF(getAvailableSlotsCF,
// uid 없이 시간만 반환)로 이관. 시그니처(Set<string> 반환)는 그대로라 호출부 4곳 무변경.
export const getBookedTimes = async (productId, date) => {
  if (!productId || !date) return new Set();
  try {
    const cf = httpsCallable(functionsAsia, 'getAvailableSlotsCF');
    const result = await cf({ productId, date });
    return new Set(result.data?.times || []);
  } catch {
    return new Set();
  }
};

// 63차: reservationService.js 끝에 추가할 함수
// ─── 점주 예약 취소 (CF 경유) ────────────────────────────────
// 보안: 서버에서 점주 권한 + 담당 매장 여부 검증
export const cancelReservationByStore = async (reservationId) => {
  const { httpsCallable } = await import('firebase/functions');
  const { functions } = await import('./firebase');
  const cf = httpsCallable(functions, 'cancelReservationByStore');
  const result = await cf({ reservationId });
  return result.data;
};

// 80차: 체험형 공연(정원제) 전용 — 방탈출 전세(getBookedTimes, 이진 Set)와 완전히
// 별개 함수로 둔다(억지로 통합하면 room 경로 회귀 위험만 커짐).
// 80차 후속: reservationSlots.read를 소유자 전용으로 좁히면서(개인정보 유출 방지) 체험형
// 슬롯(uid 없음)도 같은 규칙 아래 놓임 — 별도 CF(getShowSlotCountsCF)로 이관.
export const getShowSlotCounts = async (productId, date) => {
  if (!productId || !date) return new Map();
  try {
    const cf = httpsCallable(functionsAsia, 'getShowSlotCountsCF');
    const result = await cf({ productId, date });
    const counts = new Map();
    (result.data?.counts || []).forEach(({ time, bookedCount }) => counts.set(time, bookedCount));
    return counts;
  } catch {
    return new Map();
  }
};

// 80차: 체험형 공연 예약 생성/취소 — 정원(capacity) 검증·증감이 Admin SDK 트랜잭션
// 안에서만 이뤄져야 해서(reservationSlots.update가 firestore.rules상 완전 차단) 전부
// CF 경유(functions/index.js의 reserveShowSlotCF/cancelShowReservationCF).
export const reserveShowSlot = async (params) => {
  const cf = httpsCallable(functionsAsia, 'reserveShowSlotCF');
  const result = await cf(params);
  return result.data?.reservationId;
};

export const cancelShowReservation = async (reservationId) => {
  const cf = httpsCallable(functionsAsia, 'cancelShowReservationCF');
  await cf({ reservationId });
};

// 75차: HomeScreen "이달의 인기 테마"/"고수만 도전하는 난이도" 집계용 —
// scheduledMonthlyPopularStats(functions/index.js)가 매월 1일 서버에서 지난달
// reservations를 집계해 써두는 공개 문서(stats/monthlyPopular)를 읽기만 한다.
// 클라이언트가 reservations를 직접 스캔하지 않음(다른 유저 예약 데이터 노출 방지).
export const getMonthlyPopularStats = async () => {
  const snap = await getDoc(doc(db, 'stats', 'monthlyPopular'));
  return snap.exists() ? snap.data() : { month: null, productCounts: {} };
};